import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { IconButton, Tooltip } from "@mui/material";

export default function ColumnFilterClearButton({
  active = false,
  onClear,
  label = "Clear filter",
}) {
  if (!active || typeof onClear !== "function") return null;

  return (
    <Tooltip title={label} arrow>
      <IconButton
        size="small"
        aria-label={label}
        onClick={(event) => {
          event.stopPropagation();
          onClear();
        }}
        onMouseDown={(event) => event.stopPropagation()}
        sx={{ p: 0.25, color: "text.secondary" }}
      >
        <CloseOutlinedIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
}
